<template>
  <div class="container">
    <div class="exam">
      <template v-if="PageInfo.data.length > 0">
        <div class="exam-practice-list">
          <div
            v-for="(item, index) in PageInfo.data"
            :key="index"
            class="exam-practice"
          >
            <div class="exam-practice__title">
              <h5>{{ item.categoryName }}</h5>
              <p>
                <i class="fa fa-calendar" aria-hidden="true"></i>
                {{ $t('exam.examPeriod') }}：
                {{ item.examStartDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }} -
                {{ item.examEndDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}
              </p>
            </div>
            <div class="exam-practice__btnbox">
              <router-link
                v-if="
                  item.isExam
                    && (item.isLimitCount && item.examCount < item.limitCount || !item.isLimitCount)
                "
                class="exam-practice__btn"
                :to="`/practices/exam/${item.courseId}/${item.subjectId}`"
              >
                {{ $t('exam.button.startExam') }}
              </router-link>

              <button
                v-if="item.isLimitCount && item.examCount >= item.limitCount"
                class="exam-practice__btn exam-practice__btn--disabled"
                disabled
              >
                {{ $t('exam.message.examLimitReached') }}
              </button>

              <router-link
                class="exam-practice__btn exam-practice__btn--review"
                :to="`/practices/examHistory/${item.courseId}/${item.subjectId}`"
              >
                {{ $t('exam.button.viewScore') }}
              </router-link>
            </div>
          </div>
        </div>

        <!-- 分頁 -->
        <div class="pagination pagination--center">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="Pagination.pageIndex"
            :page-size="Pagination.pageSize"
            :total="PageInfo.count"
            @current-change="GetList()"
          />
        </div>
      </template>

      <div v-else class="exam__empty">
        <i class="el-icon-document-delete"></i>
        <p>{{ $t('exam.message.noExams') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetGotoPractice } from '@/api/BuyPracticeApi';

export default {
  data() {
    // 建立你的初始化 model data
    return {
      Args: {
        keyWord: '',
        courseId: 0,
      },
      Pagination: {
        // 有分頁要有此model data
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Args = {
        keyWord: '',
        courseId: this.$route.params?.id,
      };
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          keyWord: '',
          courseId: this.$route.params?.id,
        },
      };
      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 然後再針對頁面進行初始化資料存取
    this.GetList();
  },
  methods: {
    GetList() {
      this.Args.courseId = this.$route.params?.id;
      this.Pagination.data = { ...this.Args };
      GetGotoPractice(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;
          if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
            this.Pagination.pageIndex = 1;
            this.GetList();
          }

          const { data } = response.data;

          if (!this._.isEmpty(data)) {
            this.$emit('update:currentPage', [
              {
                name: 'learnings',
                title: this.$t('route.title.myCourses'),
                path: '',
              },
              {
                name: 'learning',
                title: `${data[0].courseName}`,
                path: `/learning/${data[0].courseId}`,
              },
              {
                name: 'practices',
                title: this.$t('route.title.exam'),
                path: '',
              },
            ]);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_exam.scss';
</style>
